module.exports = __webpack_public_path__ + "static/img/bg.2a278cb4.jpeg";